module.exports = __webpack_public_path__ + "static/img/product.817cccc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/product/product.png
// module id = tyoJ
// module chunks = 1